window.JMIRPlugins = {};

let Button = require('./public/vue/utilities/button.vue');
let Card = require('./public/vue/utilities/card.vue');
let CheckList = require('./public/vue/utilities/checklist.vue');
let Dragger = require('./public/vue/utilities/dragger.vue');
let Select = require('./public/vue/utilities/select.vue');

let Affiliation = require('./public/vue/affiliation.vue');
let Abstract = require('./public/vue/abstract.vue');
let ArticleOverrides = require('./public/vue/overrides.vue');
let Author = require('./public/vue/author.vue');
let Metadata = require('./public/vue/metadata.vue');
let AiUsageDeclaration = require('./public/vue/ai-usage-declaration.vue');
let OrcidCollection = require('./public/vue/orcid-collection.vue');
let Vendor = require('./public/vue/vendor.vue');
let Tag = require('./public/vue/tag.vue');

let Signatures = require('./public/vue/signatures.vue');
let SignaturesCreation = require('./public/vue/signatures-creation.vue');

let Checklists = require('./public/vue/checklists.vue');

let JournalSection = require('./public/vue/submission/journalSection.vue');
let ManuscriptUpload = require('./public/vue/submission/manuscriptUpload.vue');
let SubmissionChecklist = require('./public/vue/submission/submissionChecklist.vue');

let EICDashboard = require('./public/vue/eic-dashboard.vue');

JMIRPlugins.install = function(Vue) {
    //
    Vue.component('abstract', Abstract.default);
    Vue.component('article-overrides', ArticleOverrides.default);
    Vue.component('author', Author.default);
    Vue.component('affilition', Affiliation.default);
    Vue.component('metadata', Metadata.default);
    Vue.component('ai-usage-declaration', AiUsageDeclaration.default);
    Vue.component('orcid-collection', OrcidCollection.default);
    Vue.component('vendor', Vendor.default);
    Vue.component('tag', Tag.default);
    Vue.component('checklists', Checklists.default);

    Vue.component('signatures', Signatures.default);
    Vue.component('signatures-creation', SignaturesCreation.default);

    Vue.component('journal-section', JournalSection.default);
    Vue.component('manuscipt-upload', ManuscriptUpload.default);
    Vue.component('submission-checklist', SubmissionChecklist.default);

    Vue.component('check-list', CheckList.default);
    Vue.component('dragger', Dragger.default);
    Vue.component('action-button', Button.default);

    Vue.component('Card', Card.default);

    // TODO: Change this to dropdown
    Vue.component('jselect', Select.default);

    // Dashboard
    Vue.component('eic-dashboard', EICDashboard.default);
}